// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var SeatCount = function (x) {
    return x;
};
var tsBridgeSeatCount = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedNumberType("SeatCount")("__brandSeatCount"));
    }
};
var writeSeatCount = Simple_JSON.writeForeignNumber;
var unwrap = function (v) {
    return v;
};
var showSeatCount = Data_Show.showNumber;
var readSeatCount = Simple_JSON.readNumber;
var ordSeatCount = Data_Ord.ordNumber;
var newtypeSeatCount = {
    Coercible0: function () {
        return undefined;
    }
};
var makeSeatCount = SeatCount;
var eqSeatCount = Data_Eq.eqNumber;
export {
    SeatCount,
    makeSeatCount,
    unwrap,
    newtypeSeatCount,
    eqSeatCount,
    ordSeatCount,
    showSeatCount,
    readSeatCount,
    writeSeatCount,
    tsBridgeSeatCount
};
//# sourceMappingURL=index.js.map
